import { defineComponent as s, openBlock as t, createElementBlock as n, Fragment as r, renderList as a, normalizeClass as l, createElementVNode as c } from "vue";
import { _ as d } from "../../../_plugin-vue_export-helper-dad06003.js";
const p = s({
  components: {},
  emits: ["slider-paginator:click"],
  props: {
    slidesCount: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  }
});
const _ = { class: "hobi-slider-pagination tw-absolute tw-left-0 tw-right-0 tw-flex tw-justify-center tw-items-center tw-pointer-events-none tw-bottom-6" }, u = ["onClick"], m = /* @__PURE__ */ c("div", { class: "hobi-slider-pagination-single-inner tw-h-0.5 tw-rounded-sm tw-bg-white tw-w-4" }, null, -1), w = [
  m
];
function g(e, f, h, v, b, k) {
  return t(), n("div", _, [
    (t(!0), n(r, null, a(e.slidesCount, (o, i) => (t(), n("div", {
      key: o,
      class: l([
        "hobi-slider-pagination-single tw-py-1 tw-px-0 tw-cursor-pointer",
        e.activeIndex === i ? "hobi-slider-pagination-single--active" : ""
      ]),
      onClick: (y) => e.$emit("slider-paginator:click", i)
    }, w, 10, u))), 128))
  ]);
}
const x = /* @__PURE__ */ d(p, [["render", g]]);
export {
  x as default
};
